import React from 'react';
import { Star, ShieldCheck, Zap, Clock } from 'lucide-react';
export function ValidatorBar() {
  return <div className="bg-white border-y border-warm-100 py-6" data-id="element-265">
      <div className="max-w-6xl mx-auto px-4" data-id="element-266">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6" data-id="element-267">
          {/* Rating */}
          <div className="flex flex-col items-center md:items-start gap-1" data-id="element-268">
            <div className="flex items-center gap-1" data-id="element-269">
              {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-5 h-5 fill-accent text-accent" data-id="element-270" />)}
              <span className="font-heading font-bold text-lg ml-2 text-charcoal" data-id="element-271">
                4.9/5
              </span>
            </div>
            <span className="text-xs text-charcoal-muted" data-id="element-272">
              (basado en opiniones reales)
            </span>
          </div>

          {/* Trust Icons */}
          <div className="flex flex-wrap justify-center gap-4 md:gap-8" data-id="element-273">
            <div className="flex items-center gap-2" data-id="element-274">
              <ShieldCheck className="w-5 h-5 text-trust" data-id="element-275" />
              <span className="text-sm font-medium text-charcoal" data-id="element-276">
                Pago seguro
              </span>
            </div>
            <div className="flex items-center gap-2" data-id="element-277">
              <Zap className="w-5 h-5 text-accent" data-id="element-278" />
              <span className="text-sm font-medium text-charcoal" data-id="element-279">
                Entrega inmediata
              </span>
            </div>
            <div className="flex items-center gap-2" data-id="element-280">
              <Clock className="w-5 h-5 text-trust" data-id="element-281" />
              <span className="text-sm font-medium text-charcoal" data-id="element-282">
                Garantía 7 días
              </span>
            </div>
          </div>

          {/* Social Proof */}
          <div className="bg-warm-50 px-4 py-2 rounded-full border border-warm-100" data-id="element-283">
            <p className="text-sm font-medium text-charcoal text-center" data-id="element-284">
              Más de{' '}
              <span className="font-bold text-primary" data-id="element-285">250 colombianas</span> ya
              cocinaron típico sin paila
            </p>
          </div>
        </div>
      </div>
    </div>;
}